import clsx from 'clsx';
import { BellIcon } from '@heroicons/react/24/outline';

import {
  formatNotificationWhen,
  notificationLink,
  notificationTypeLabel,
} from '../../utils/notificationLinks';

export default function NotificationList({
  items = [],
  loading = false,
  emptyTitle = 'Nothing here yet',
  emptyDescription = 'Notifications appear here from now on. Older delivery log rows were recorded before we tracked who each one was for, so they cannot be shown in your inbox.',
  onItemActivate,
  compact = false,
}) {
  if (loading && items.length === 0) {
    return <p className="px-4 py-8 text-sm text-surface-500 text-center">Loading…</p>;
  }

  if (!items.length) {
    return (
      <div className={clsx('text-center', compact ? 'px-4 py-8' : 'px-6 py-12')}>
        <BellIcon className="mx-auto h-10 w-10 text-surface-300" />
        <p className="mt-3 text-sm font-medium text-dark-900">{emptyTitle}</p>
        <p className="mt-1 text-xs leading-relaxed text-surface-500 max-w-sm mx-auto">
          {emptyDescription}
        </p>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-surface-100">
      {items.map((item) => {
        const href = notificationLink(item);
        const unread = !item.readAt;
        return (
          <li key={item._id}>
            <button
              type="button"
              onClick={() => onItemActivate?.(item, href)}
              className={clsx(
                'w-full text-left transition-colors hover:bg-surface-50',
                compact ? 'px-4 py-3' : 'px-5 py-4',
                unread && 'bg-brand-50/40',
                href && 'cursor-pointer',
              )}
            >
              <p className={clsx('text-sm', unread ? 'font-semibold text-dark-900' : 'text-surface-700')}>
                {item.message || notificationTypeLabel(item.notificationType)}
              </p>
              <p className="mt-1 text-[11px] text-surface-400">
                {formatNotificationWhen(item.createdAt)}
                {item.notificationType ? ` · ${notificationTypeLabel(item.notificationType)}` : ''}
              </p>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
